import { render, staticRenderFns } from "./select-company-by-service.vue?vue&type=template&id=5136b1dc"
import script from "./select-company-by-service.vue?vue&type=script&lang=js"
export * from "./select-company-by-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports